// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const LeadsPage = lazy(() => import('./pages/LeadsPage'));
const DealsPipelinePage = lazy(() => import('./pages/DealsPipelinePage'));
const ActivitiesPage = lazy(() => import('./pages/ActivitiesPage'));
const SimpleForecastPage = lazy(() => import('./pages/SimpleForecastPage'));

export const EssentialsRoutes: RouteObject = {
  path: 'essentials',
  element: <ModuleGuard moduleId="sales.essentials" />,
  children: [
    { path: 'leads', element: <LeadsPage />, handle: { crumb: 'Leads' } },
    { path: 'deals-pipeline', element: <DealsPipelinePage />, handle: { crumb: 'Deals Pipeline' } },
    { path: 'activities', element: <ActivitiesPage />, handle: { crumb: 'Activities' } },
    { path: 'simple-forecast', element: <SimpleForecastPage />, handle: { crumb: 'Simple Forecast' } },
  ],
};
